import { render, staticRenderFns } from "./pageDiagnosis6.vue?vue&type=template&id=6a1529b9&scoped=true"
import script from "./pageDiagnosis6.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis6.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis6.vue?vue&type=style&index=0&id=6a1529b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1529b9",
  null
  
)

export default component.exports